// Tables.js
import React from 'react';
import { MonthConvert, MonthConvert_year } from './utility'

const trimstre = {
  "first": 'Trimester Pertama',
  'second': 'Trimester Kedua',
  'third': 'Trimester Ketiga'
}

function PeriodTable({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (
      <table >
        <thead>
          <tr>
            <th >Siklus Menstruasi</th>
            <th >Hari Ovulasi yang Paling Mungkin</th>
          </tr>
        </thead>
        <tbody>
          {result.map((item, index) => (
            <tr className="">
              <td>{MonthConvert(item.startDatePeriods)} - {MonthConvert(item.endDatePeriods)}</td>
              <td>{MonthConvert(item.ovulationWindowStart)} - {MonthConvert(item.ovulationWindowEnd)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

function OvulationTable({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    const response = result
    return (
      <table >
        <thead>
          <tr className='highlightedOk'>
            <th className="">Status</th>
            <th className="">Hasil</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Tanggal Ovulasi Paling Mungkin</td>
            <td>{MonthConvert_year(result.mostProbableOvulationDate)}</td>
          </tr>
          <tr>
            <td>Jendela Hubungan Intim untuk Kehamilan</td>
            <td>{MonthConvert_year(result.intercourseWindowForPregnancy)}</td>
          </tr>
          <tr>
            <td>Tes Kehamilan</td>
            <td>{MonthConvert_year(result.pregnancyTest)}</td>
          </tr>
          <tr>
            <td>Mulai Siklus Menstruasi Berikutnya</td>
            <td>{MonthConvert_year(result.nextPeriodStart)}</td>
          </tr>
          <tr>
            <td>Tanggal Lahir jika Hamil</td>
            <td>{MonthConvert_year(result.dueDateIfPregnant)}</td>
          </tr>
        </tbody>
      </table>
    )
  }
}

function OvulationTableV2({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    const response = result.importantDatesForNextSixMonths
    return (
      <table >
        <thead>
          <tr>
            <th >Mulai Siklus Menstruasi</th>
            <th >Jendela Ovulasi</th>
            <th >Tanggal Perkiraan Lahir</th>
          </tr>
        </thead>
        <tbody>
          {response.map((item, index) => (
            <tr className="">
              <td>{MonthConvert_year(item.startDatePeriods)}</td>
              <td>{MonthConvert_year(item.ovulationWindowStart)} - {MonthConvert_year(item.ovulationWindowEnd)}</td>
              <td>{MonthConvert_year(item.dueDate)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

function ConceptionTable({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (
      <table >
        <thead>
          <tr>
            <th >Mulai Siklus Menstruasi</th>
            <th >Jendela Pembuahan</th>
            <th >Tanggal Perkiraan Lahir</th>
          </tr>
        </thead>
        <tbody>
          {result.map((item, index) => (
            <tr className="">
              <td>{MonthConvert_year(item.startDatePeriods)}</td>
              <td>{MonthConvert_year(item.conceptionWindowStart)} - {MonthConvert_year(item.conceptionWindowEnd)}</td>
              <td>{MonthConvert_year(item.dueDate)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

function PregnancyTable({ result }) {
  if (Response === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    let response = result;
    return (
      <table >
        <thead>
          <tr>
            <th >Status</th>
            <th > Hasil</th>
          </tr>
          <tr>
            <td > Anda berada di minggu ke-</td>
            <td > {response.currentWeek} ( {response.numberOfWeeks} minggu dan {response.remainingDays} hari <b>atau</b> {response.months} bulan dan {response.daysMonth} hari)</td>
          </tr>
        </thead>
        <tbody>
          <tr className="">
            <td>Perkiraan tanggal lahir adalah</td>
            <td>{MonthConvert_year(response.dueDate)}</td>
          </tr>
          <tr className="">
            <td> Kemungkinan kehamilan terjadi pada</td>
            <td>{MonthConvert_year(response.conceivedDate)}</td>
          </tr>
          <tr className="">
            <td> Anda berada di</td>
            <td>{trimstre[response.trimstre]}</td>
          </tr>
          <tr className="">
            <td> Anda telah menyelesaikan</td>
            <td>{response.percentageOfPregnancyTime}% dari masa kehamilan</td>
          </tr>
        </tbody>
      </table>
    );
  }
}

function PregnancyWeightTable({ Response, WeightBforePregnancy }) {
  if (Response === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    let response = Response;
    var range = ""
    var bmi = ''
    if (response.weightclassification === 'higher') { range = "Berat badan Anda saat ini di atas kisaran yang direkomendasikan." }
    if (response.weightclassification === 'lower') { range = "Berat badan Anda saat ini di bawah kisaran yang direkomendasikan." }
    if (response.weightclassification === 'normal') { range = "Berat badan Anda saat ini dalam kisaran yang direkomendasikan." }
    if (response.bmiResult.BMIclassification === 'Underweight') { bmi = 'Berat badan kurang' }
    if (response.bmiResult.BMIclassification === 'Normal weight') { bmi = 'Berat badan normal' }
    if (response.bmiResult.BMIclassification === 'Overweight') { bmi = 'Kelebihan berat badan' }
    if (response.bmiResult.BMIclassification === 'Obese') { bmi = 'Obesitas' }
    return (
      <table >
        <thead>
          <tr>
            <td > Kisaran berat badan yang direkomendasikan pada minggu ke-{response.week}</td>
            <td > <b>{response.recommended.max}</b> - <b>{response.recommended.min}</b></td>
          </tr>
        </thead>
        <tbody>
          <tr className="">
            <td>Kisaran berat badan yang direkomendasikan saat melahirkan (minggu ke-40)</td>
            <td><b>{response.recommendedWeightDelivering.max}</b> - <b>{response.recommendedWeightDelivering.min}</b></td>
          </tr>
          <tr className={response.bmiResult.BMIclassification}>
            <td> <b>({bmi})</b> Indeks Massa Tubuh (BMI)</td>
            <td><b>{response.bmiResult.BMI}</b> kg/m²&nbsp;</td>
          </tr>
          <tr className="">
            <td colSpan="3">
              {range}</td>
          </tr>
        </tbody>
      </table>
    );
  }
}

function PregnancyWeight50Table({ Response, WeightBforePregnancy }) {
  if (Response === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    let response = Response;
    var range = ""
    var bmi = ''
    if (response.weightclassification === 'higher') { range = "Berat badan Anda saat ini di atas kisaran yang direkomendasikan." }
    if (response.weightclassification === 'lower') { range = "Berat badan Anda saat ini di bawah kisaran yang direkomendasikan." }
    if (response.weightclassification === 'normal') { range = "Berat badan Anda saat ini dalam kisaran yang direkomendasikan." }
    if (response.bmiResult.BMIclassification === 'Underweight') { bmi = 'Berat badan kurang' }
    if (response.bmiResult.BMIclassification === 'Normal weight') { bmi = 'Berat badan normal' }
    if (response.bmiResult.BMIclassification === 'Overweight') { bmi = 'Kelebihan berat badan' }
    if (response.bmiResult.BMIclassification === 'Obese') { bmi = 'Obesitas' }
    return (
      <table >
        <thead>
          <tr>
            <td className='bmi-header'> Minggu</td>
            <td className='bmi-header'> Kisaran berat badan yang direkomendasikan</td>
            <td className='bmi-header'> Kenaikan berat badan yang direkomendasikan</td>
          </tr>
        </thead>
        <tbody>
          {response.maxWeightValues.map((item, index) => (
            <tr className="">
              <td> Minggu ke-{index + 1}</td>
              <td>{WeightBforePregnancy + response.minWeightValues[index]} - {WeightBforePregnancy + response.maxWeightValues[index]}</td>
              <td>{response.minWeightValues[index]} - {response.maxWeightValues[index]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}

function ConceptionTablev2({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    let response = result;
    return (
      <table >
        <thead>
          <th >Status</th>
          <th > Hasil</th>
          <tr>
            <td >Tanggal pembuahan yang paling mungkin</td>
            <td > {MonthConvert_year(response.mostProbableConceptionWindowStart)} hingga {MonthConvert_year(response.mostProbableConceptionWindowEnd)}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td >Tanggal hubungan seksual yang paling mungkin menyebabkan kehamilan</td>
            <td > {MonthConvert_year(response.mostProbableDatesSexualIntercourseStart)} hingga {MonthConvert_year(response.mostProbabledatesSexualIntercourseEnd)}</td>
          </tr>
          <tr>
            <td >Kemungkinan tanggal pembuahan</td>
            <td > {MonthConvert_year(response.possibleConceptionWindowStart)} hingga {MonthConvert_year(response.possibleConceptionWindowEnd)}</td>
          </tr>
          <tr>
            <td>
              Kemungkinan tanggal hubungan seksual yang menyebabkan kehamilan:
            </td>
            <td>
              {MonthConvert_year(response.possibleDatesSexualIntercourseStart)} hingga {MonthConvert_year(response.possibleDatesSexualIntercourseEnd)}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

function OvulationTableFull({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (<div className="col">
      <p>Tanggal penting untuk siklus ini:</p>
      <OvulationTable result={result}></OvulationTable>
      <br></br>
      <br></br>
      <p>Tanggal penting untuk enam siklus berikutnya:</p>
      <OvulationTableV2 result={result}></OvulationTableV2>
    </div>)
  }
}

function DueDateTable({ result }) {
    return (
      <table >
      <thead>
        <tr>
          <th >Status</th>
          <th > Hasil</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td> Perkiraan tanggal lahir</td>
          <td>{MonthConvert_year(result.dueDate)}</td>
        </tr>
        <tr >
          <td>Anda berada di</td>
          <td> minggu ke-{result.currentWeek} ({result.numberOfWeeks} minggu dan {result.remainingDays} hari atau {result.months} bulan dan {result.daysMonth} hari) kehamilan.</td>
        </tr>
        <tr >
          <td>Anda berada di</td>
          <td> {trimstre[result.trimstre]} masa kehamilan</td>
        </tr>
        <tr >
          <td>Anda telah menyelesaikan</td>
          <td> {result.percentageof40Week}% dari total masa kehamilan</td>
        </tr>
      </tbody>
    </table>
    )
}

export { DueDateTable, PeriodTable, ConceptionTable, OvulationTable, PregnancyTable, PregnancyWeightTable, PregnancyWeight50Table, ConceptionTablev2, OvulationTableV2, OvulationTableFull };